export default __webpack_public_path__ + "static/media/forward.0ed110a0.svg";